let winWidth = window.outerWidth;

// Main Slider
var mainSlider = new Swiper(".main-slider-sfj", {
  slidesPerView: 1,
  autoplay: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

// Featured Collections Slider
var featuredCollSwiper = new Swiper(".featuredColl_swiper-sfj", {
  slidesPerView: 1.5,
  spaceBetween: 10,
  noSwiping:true,
  noSwipingClass:"product-media-wrapper",
  // 320: {
  //   cssMode: true,
  //   grabCursor: true,
  // },
  breakpoints: {
    750: {
      slidesPerView: 4,
      spaceBetween: 15,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      // cssMode: true,
      // grabCursor: true,
      // keyboard: {
      //   enabled: true,
      // },
      // mousewheel: true,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: false,
      },
      keyboard: {
        enabled: true,
      },
     mousewheel: {
                enabled: true,
                forceToAxis: true
            },
    },
  },
});

const engagementRingSlider = new Swiper(".engagement-ring-slider", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination1",
    clickable: true,
  },
  breakpoints: {
    750: {
      freeMode: {
        enabled: true,
        sticky: true,
        momentumBounce: true,
      },
      keyboard: {
        enabled: true,
      },
     mousewheel: {
                enabled: true,
                forceToAxis: true
            },
    }
  },
  
});

const shopByCharacter = new Swiper(".swiper-shopByCharacter", {
  slidesPerView: 3.5,
  spaceBetween: 18,
  breakpoints: {
    320: {
      slidesPerView: 1.6,
      spaceBetween: 16,
    },
    480: {
      slidesPerView: 1.8,
      spaceBetween: 16,
    },
    750: {
      slidesPerView: 2.6,
      spaceBetween: 16,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: false,
      },
      keyboard: {
        enabled: true,
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
    },
    991: {
      slidesPerView: 3.5,
      spaceBetween: 18,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: false,
      },
      keyboard: {
        enabled: true,
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
    },
  },
});

const swiperCategory = new Swiper(".swiper-category", {
  slidesPerView: 6,
  spaceBetween: 16,
  keyboard: {
    enabled: true,
  },
  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    // when window width is >= 640px
    750: {
      slidesPerView: 4,
      spaceBetween: 16,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: false,
      },
      keyboard: {
        enabled: true,
      },
     mousewheel: {
                enabled: true,
                forceToAxis: true
            },
    },
    1240: {
      slidesPerView: 6,
      spaceBetween: 16,
    },
  },
  
});

const swiperFeatures = new Swiper(".swiper-facility", {
  slidesPerView: 4,
 
  breakpoints: {
    320: {
      slidesPerView: 1,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
      },
    },
    759: {
      slidesPerView: 3,
      spaceBetween: 16,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
      },
      freeMode: {
        enabled: true,
        sticky: true,
        momentumBounce: true,
      },
      keyboard: {
        enabled: true,
      },
     mousewheel: {
                enabled: true,
                forceToAxis: true
            },
    }, 
  },
  
});

// swiper-sjf-image
const swiperSjfImages = new Swiper(".swiper-media-models-image", {
  slidesPerView: 3.8,
  spaceBetween: 15,
  breakpoints: {
    320: {
      slidesPerView: 2.2,
      spaceBetween: 15,
    },
    480: {
      slidesPerView: 2.8,
      spaceBetween: 15,
    },
    750: {
      slidesPerView: 3.8,
      spaceBetween: 15,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: false,
      },
      keyboard: {
        enabled: true,
      },
     mousewheel: {
                enabled: true,
                forceToAxis: true
            },
    } 
     
  },
  
});

var swiper = new Swiper(`.product-media-wrapper`, {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: `.swiper-pagination`,
    clickable: true,
  },
  breakpoints: {
    750: {
      keyboard: {
        enabled: true,
      },
      mousewheel: true,
    },
  },
});



// Get the header element
let header = document.querySelector("sticky-header");

// Get the height of the header
let headerHeight = header.offsetHeight;
// console.log(headerHeight);

document
  .querySelectorAll(".collection-button-next a")
  .forEach(function (anchor) {
    anchor.addEventListener("click", function (event) {
      event.preventDefault();

      // Get the target element that
      // the anchor link points to
      let target = document.querySelector(this.getAttribute("href"));
      let targetPosition = target.getBoundingClientRect().top - headerHeight;
      window.scrollTo({
        top: targetPosition + window.scrollY,
        behavior: "smooth",
      });
    });
  });

// SCRIPT TO PLAY NAV VIDEO ON NAV HOVER
const hoverElement = document.querySelector(".starwars-mega-menu__gifts");
const hoverVideo = document.getElementById("nav-video");
// Event listener for hover
hoverElement.addEventListener("mouseenter", () => {
  console.log("mouse enter");
  hoverVideo.play();
});

// ============== PLP SCRIPTS ================ //
var collHeroSwiper = new Swiper(".collection-hero__shop-all", {
  slidesPerView: 1.25,
  spaceBetween: 10,
  autoplay: false,
  breakpoints: {
    750: {
      slidesPerView: 4,
      spaceBetween: 15,
    },
  },
});

// ============== PDP - PROTECTION PLAN SCRIPTS starts here ================ //
$(document).on("click", ".protection-plan-wrapper .commitment-popup-btn", function () {
  const popup = $("#protection-plan-popup");
  if ($(this).closest(".product-clarity-commitment").length) {
    popup.find(".protection-plan-wrapper").hide();
    popup.find(".lifetime-info").hide();
    popup.find(".see-details").show();
    popup.find(".btn-wrapper").hide();
  }
  popup.addClass("active");
});
$(document).on("click", ".popup-content .close-popup", function () {
  $("#protection-plan-popup").removeClass("active");
});
$(document).on("click", ".protection-plan-wrapper label", function () {
  var closest_parent = $(this).closest(".grid__item");
  closest_parent.siblings().find("input").prop("checked", false);
  if (closest_parent.find("input").prop("checked")) {
    closest_parent.find("input").prop("checked", false);
    closest_parent.closest(".protection-plan-wrapper").find(".lifetime-info").hide();
  } else {
    closest_parent.find("input").prop("checked", true);
    var inputValue = closest_parent.find("input").val();
    if (inputValue == "Lifetime") {
      closest_parent.closest(".protection-plan-wrapper").find(".lifetime-info").show();
    } else {
      closest_parent.closest(".protection-plan-wrapper").find(".lifetime-info").hide();
    }
  }
});
// ============== PDP - PROTECTION PLAN SCRIPTS ends here ================ //